import quality from '../img/services/quality.png';
import delivery from '../img/services/delivery.png';
import yummy from '../img/services/yummy.png';

const Service = () => {
  return (
    <section id="services" className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-20">
          <h1
            className="
              text-5xl
              font-medium
              title-font
              mb-4
            "
          >
            Our Amazing Services
          </h1>
          <div className="flex mt-6 justify-center">
            <div
              className="
                w-28
                h-2
                rounded-full
                bg-purple-500
                inline-flex
              "
            ></div>
          </div>
        </div>
        <div
          className="
            flex flex-wrap
            sm:-m-4
            -mx-4
            -mb-10
            -mt-4
            md:space-y-0
            space-y-6
          "
        >
          <div
            className="
              p-4
              md:w-1/3
              flex flex-col
              text-center
              items-center
            "
          >
            <div
              className="
                w-20
                h-20
                inline-flex
                items-center
                justify-center
                rounded-full
                bg-purple-100
                text-purple-500
                mb-5
                flex-shrink-0
              "
            >
              <img src={yummy} alt="yummy" />
            </div>
            <div className="flex-grow">
              <h2
                className="
                  text-2xl
                  title-font
                  font-medium
                  mb-3
                "
              >
                Yummy Food
              </h2>
              <p className="leading-relaxed text-base">
                All of our cakes are made fresh from scratch with every order
                from home. So you will enjoy every bit.
              </p>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/Sliceofdream"
                className="
                  mt-3
                  text-purple-500
                  inline-flex
                  items-center
                "
              >
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
          <div
            className="
              p-4
              md:w-1/3
              flex flex-col
              text-center
              items-center
            "
          >
            <div
              className="
                w-20
                h-20
                inline-flex
                items-center
                justify-center
                rounded-full
                bg-purple-100
                text-purple-500
                mb-5
                flex-shrink-0
              "
            >
              <img src={quality} alt="quality" />
            </div>
            <div className="flex-grow">
              <h2
                className="
                  text-2xl
                  title-font
                  font-medium
                  mb-3
                "
              >
                Excellent Quality
              </h2>
              <p className="leading-relaxed text-base">
                All of our cakes are made fresh from scratch with every order
                from home. So the food quality will be excellent.
              </p>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/Sliceofdream"
                className="
                  mt-3
                  text-purple-500
                  inline-flex
                  items-center
                "
              >
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
          <div
            className="
              p-4
              md:w-1/3
              flex flex-col
              text-center
              items-center
            "
          >
            <div
              className="
                w-20
                h-20
                inline-flex
                items-center
                justify-center
                rounded-full
                bg-purple-100
                text-purple-500
                mb-5
                flex-shrink-0
              "
            >
              <img src={delivery} alt="delivery" />
            </div>
            <div className="flex-grow">
              <h2
                className="
                  text-2xl
                  title-font
                  font-medium
                  mb-3
                "
              >
                Good Delivery
              </h2>
              <p className="leading-relaxed text-base">
                You don't need to worry about the delivery. We provide the best
                delivery service. So just relax & enjoy the yummy cake.
              </p>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/Sliceofdream"
                className="
                  mt-3
                  text-purple-500
                  inline-flex
                  items-center
                "
              >
                Learn More
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
